// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file actions/v1/caches_index.proto (package github.actions.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file actions/v1/caches_index.proto.
 */
export const file_actions_v1_caches_index: GenFile = /*@__PURE__*/
  fileDesc("Ch1hY3Rpb25zL3YxL2NhY2hlc19pbmRleC5wcm90bxIRZ2l0aHViLmFjdGlvbnMudjEigQMKEkNhY2hlc0luZGV4UGF5bG9hZBIxCgtjYWNoZV9pdGVtcxgBIAMoCzIcLmdpdGh1Yi5hY3Rpb25zLnYxLkNhY2hlSXRlbRITCgt0b3RhbF9jb3VudBgCIAEoAxIMCgRwYWdlGAMgASgFEhAKCHBlcl9wYWdlGAQgASgFEhMKC3RvdGFsX3BhZ2VzGAUgASgFEg0KBXF1ZXJ5GAYgASgJEjAKB2ZpbHRlcnMYByABKAsyHy5naXRodWIuYWN0aW9ucy52MS5DYWNoZUZpbHRlcnMSLAoFdXNhZ2UYCCABKAsyHS5naXRodWIuYWN0aW9ucy52MS5DYWNoZVVzYWdlEhIKCmNhbl9kZWxldGUYCSABKAgSEwoLY2FjaGVzX3BhdGgYCiABKAkSFQoNYnJhbmNoZXNfcGF0aBgLIAEoCRIYChBjYWNoaW5nX2hlbHBfdXJsGAwgASgJEhYKDnVzYWdlX2hlbHBfdXJsGA0gASgJEg0KBWVycm9yGA4gASgJIroCCglDYWNoZUl0ZW0SCgoCaWQYASABKAMSCwoDcmVmGAIgASgJEgsKA2tleRgDIAEoCRIPCgd2ZXJzaW9uGAQgASgJEi4KCmNyZWF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjQKEGxhc3RfYWNjZXNzZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhUKDXNpemVfaW5fYnl0ZXMYByABKAMSEwoLYnJhbmNoX25hbWUYCCABKAkSMQoLYnJhbmNoX3BhdGgYCSABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSMQoLZGVsZXRlX3BhdGgYCiABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUiOQoMQ2FjaGVGaWx0ZXJzEgsKA2tleRgBIAEoCRIOCgZicmFuY2gYAiABKAkSDAoEc29ydBgDIAEoCSJkCgpDYWNoZVVzYWdlEhYKDmNhY2hlX2xpbWl0X2diGAEgASgBEh0KFWN1cnJlbnRfY2FjaGVfc2l6ZV9nYhgCIAEoARIfChdhYm92ZV93YXJuaW5nX3RocmVzaG9sZBgDIAEoCGIGcHJvdG8z", [file_google_protobuf_timestamp, file_google_protobuf_wrappers]);

/**
 * Index data for the Caches route, independent of the shared Actions shell.
 *
 * @generated from message github.actions.v1.CachesIndexPayload
 */
export type CachesIndexPayload = Message<"github.actions.v1.CachesIndexPayload"> & {
  /**
   * @generated from field: repeated github.actions.v1.CacheItem cache_items = 1;
   */
  cacheItems: CacheItem[];

  /**
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 per_page = 4;
   */
  perPage: number;

  /**
   * @generated from field: int32 total_pages = 5;
   */
  totalPages: number;

  /**
   * @generated from field: string query = 6;
   */
  query: string;

  /**
   * @generated from field: github.actions.v1.CacheFilters filters = 7;
   */
  filters?: CacheFilters;

  /**
   * @generated from field: github.actions.v1.CacheUsage usage = 8;
   */
  usage?: CacheUsage;

  /**
   * @generated from field: bool can_delete = 9;
   */
  canDelete: boolean;

  /**
   * @generated from field: string caches_path = 10;
   */
  cachesPath: string;

  /**
   * @generated from field: string branches_path = 11;
   */
  branchesPath: string;

  /**
   * @generated from field: string caching_help_url = 12;
   */
  cachingHelpUrl: string;

  /**
   * @generated from field: string usage_help_url = 13;
   */
  usageHelpUrl: string;

  /**
   * Only populated on a cache service failure (HTTP 503).
   *
   * @generated from field: string error = 14;
   */
  error: string;
};

/**
 * Describes the message github.actions.v1.CachesIndexPayload.
 * Use `create(CachesIndexPayloadSchema)` to create a new message.
 */
export const CachesIndexPayloadSchema: GenMessage<CachesIndexPayload> = /*@__PURE__*/
  messageDesc(file_actions_v1_caches_index, 0);

/**
 * @generated from message github.actions.v1.CacheItem
 */
export type CacheItem = Message<"github.actions.v1.CacheItem"> & {
  /**
   * Treat identifiers as opaque strings in proto3-JSON, including when deleting.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string ref = 2;
   */
  ref: string;

  /**
   * @generated from field: string key = 3;
   */
  key: string;

  /**
   * @generated from field: string version = 4;
   */
  version: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_accessed_at = 6;
   */
  lastAccessedAt?: Timestamp;

  /**
   * @generated from field: int64 size_in_bytes = 7;
   */
  sizeInBytes: bigint;

  /**
   * @generated from field: string branch_name = 8;
   */
  branchName: string;

  /**
   * Pull refs are displayed as text and have no branch link.
   *
   * @generated from field: google.protobuf.StringValue branch_path = 9;
   */
  branchPath?: string;

  /**
   * Absent unless the viewer has repository write access.
   *
   * @generated from field: google.protobuf.StringValue delete_path = 10;
   */
  deletePath?: string;
};

/**
 * Describes the message github.actions.v1.CacheItem.
 * Use `create(CacheItemSchema)` to create a new message.
 */
export const CacheItemSchema: GenMessage<CacheItem> = /*@__PURE__*/
  messageDesc(file_actions_v1_caches_index, 1);

/**
 * @generated from message github.actions.v1.CacheFilters
 */
export type CacheFilters = Message<"github.actions.v1.CacheFilters"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * Existing query syntax: accessed-desc/asc, created-desc/asc, size-desc/asc.
   *
   * @generated from field: string sort = 3;
   */
  sort: string;
};

/**
 * Describes the message github.actions.v1.CacheFilters.
 * Use `create(CacheFiltersSchema)` to create a new message.
 */
export const CacheFiltersSchema: GenMessage<CacheFilters> = /*@__PURE__*/
  messageDesc(file_actions_v1_caches_index, 2);

/**
 * @generated from message github.actions.v1.CacheUsage
 */
export type CacheUsage = Message<"github.actions.v1.CacheUsage"> & {
  /**
   * @generated from field: double cache_limit_gb = 1;
   */
  cacheLimitGb: number;

  /**
   * @generated from field: double current_cache_size_gb = 2;
   */
  currentCacheSizeGb: number;

  /**
   * @generated from field: bool above_warning_threshold = 3;
   */
  aboveWarningThreshold: boolean;
};

/**
 * Describes the message github.actions.v1.CacheUsage.
 * Use `create(CacheUsageSchema)` to create a new message.
 */
export const CacheUsageSchema: GenMessage<CacheUsage> = /*@__PURE__*/
  messageDesc(file_actions_v1_caches_index, 3);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(CachesIndexPayloadSchema, "8ed8f7b4d8e6")
registerSchemaHash(CacheItemSchema, "0e5559fb70a3")
registerSchemaHash(CacheFiltersSchema, "212771ade9b4")
registerSchemaHash(CacheUsageSchema, "08695758aa0e")
